import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTheme } from 'styled-components';
import { StyledButton } from '../../../globalStyled';
import {
  StyledPopUp,
  StyledPopUpBlock,
  StyledCross,
  StyledPopUpContainer,
  StyledButtonContainer,
  StyledHeader,
} from '../styled';
import {
  StyledSection,
  StyledSectionLabel,
  StyledHint,
  StyledSelect,
  StyledAccentRow,
  StyledAccentChoice,
  StyledAccentSwatch,
  StyledRadiusPreview,
} from './styled';
import {
  StyledThemeChoices,
  StyledThemeChoice,
  StyledThemePreview,
  StyledThemeSwatch,
} from '../../UserDropdown/styled';
import { hidePopupWindow } from '../../../redux/actions/Popups';
import { useThemeMode } from '../../../theme/ThemeRoot';
import { ACCENT_OPTIONS, RADIUS_OPTIONS, THEME_OPTIONS } from '../../../theme/palettes';
import {
  TIMEZONE_OPTIONS,
  getTimezonePreference,
  setDisplayTimezone,
} from '../../../service/localTime';

const SettingsPopup = ({ popupName }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const { mode, setMode, accentId, setAccentId, radiusId, setRadiusId } =
    useThemeMode();
  const [timezoneId, setTimezoneId] = useState(getTimezonePreference);

  const hidePopup = () => {
    dispatch(hidePopupWindow(popupName));
  };

  return (
    <StyledPopUp>
      <StyledPopUpBlock maxWidth={480}>
        <StyledCross onClick={() => hidePopup()} />
        <StyledPopUpContainer noOverflow>
          <StyledHeader>Appearance</StyledHeader>

          <StyledSection>
            <StyledSectionLabel>Theme</StyledSectionLabel>
            <StyledThemeChoices>
              {THEME_OPTIONS.map((option) => (
                <StyledThemeChoice
                  key={option.id}
                  type="button"
                  $selected={mode === option.id}
                  onClick={() => setMode(option.id)}
                >
                  <StyledThemePreview $selected={mode === option.id}>
                    <StyledThemeSwatch
                      $rail={option.rail}
                      $nav={option.nav}
                      $page={option.page}
                    />
                  </StyledThemePreview>
                  {option.label}
                </StyledThemeChoice>
              ))}
            </StyledThemeChoices>
          </StyledSection>

          <StyledSection>
            <StyledSectionLabel>Corners</StyledSectionLabel>
            <StyledHint>
              How round the page sheet and cards are.
            </StyledHint>
            <StyledThemeChoices>
              {RADIUS_OPTIONS.map((option) => (
                <StyledThemeChoice
                  key={option.id}
                  type="button"
                  $selected={radiusId === option.id}
                  onClick={() => setRadiusId(option.id)}
                >
                  <StyledRadiusPreview
                    $selected={radiusId === option.id}
                    $chrome={option.chrome}
                    $card={option.card}
                  >
                    <span />
                  </StyledRadiusPreview>
                  {option.label}
                </StyledThemeChoice>
              ))}
            </StyledThemeChoices>
          </StyledSection>

          {theme.isDark ? (
            <StyledSection>
              <StyledSectionLabel>Accent</StyledSectionLabel>
              <StyledHint>
                Header, selected tabs, buttons, links, loaders, and live match.
                Light mode stays green.
              </StyledHint>
              <StyledAccentRow>
                {ACCENT_OPTIONS.map((option) => (
                  <StyledAccentChoice
                    key={option.id}
                    type="button"
                    $selected={accentId === option.id}
                    onClick={() => setAccentId(option.id)}
                  >
                    <StyledAccentSwatch
                      $color={option.color}
                      $selected={accentId === option.id}
                      $outline={option.id === 'white'}
                    />
                    {option.label}
                  </StyledAccentChoice>
                ))}
              </StyledAccentRow>
            </StyledSection>
          ) : null}

          <StyledSection>
            <StyledSectionLabel>Timezone</StyledSectionLabel>
            <StyledHint>
              Kick-off stays 19:00 league / 12:00 cup in the server zone. Times
              on screen follow this setting.
            </StyledHint>
            <StyledSelect
              aria-label="Timezone"
              classNamePrefix="react-select"
              isSearchable={false}
              menuPlacement="auto"
              value={TIMEZONE_OPTIONS.map(option=>({value:option.id,label:option.label})).find(option=>option.value===timezoneId)}
              options={TIMEZONE_OPTIONS.map(option=>({value:option.id,label:option.label}))}
              onChange={(option) => {
                setTimezoneId(option.value);
                setDisplayTimezone(option.value);
              }}
            />
          </StyledSection>

          <StyledButtonContainer>
            <StyledButton primary type="button" onClick={() => hidePopup()}>
              Done
            </StyledButton>
          </StyledButtonContainer>
        </StyledPopUpContainer>
      </StyledPopUpBlock>
    </StyledPopUp>
  );
};

export default React.memo(SettingsPopup);
